// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-dialog-delete-entry__entry {
  display: flex;
  align-items: center;
  font-size: 15px;
}
.dl-dialog-delete-entry__entry-text {
  margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntryDialogues/DialogDeleteEntry/DialogDeleteEntry.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AAAR;AAGI;EACI,iBAAA;AADR","sourcesContent":[".dl-dialog-delete-entry__entry {\n  display: flex;\n  align-items: center;\n  font-size: 15px;\n}\n.dl-dialog-delete-entry__entry-text {\n  margin-right: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
